import React, { Component } from 'react';

import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';

import Theme from '../Theme';

const washTypes = [
  // {
  //   name: 'Outie',
  //   displayName: 'Silver',
  //   price: 29,
  //   points: [
  //     'Quick Exterior Hand Wash',
  //     'Tyre Shine & Rim Wipedown',
  //     'Windows Cleaned (Outside Only)'
  //   ]
  // },
  // {
  //   name: 'Full\'o',
  //   displayName: 'Gold',
  //   price: 49,
  //   points: [
  //     'Quick Exterior Hand Wash',
  //     'Tyre Shine & Rim Wipedown',
  //     'Windows Cleaned (Inside + Outside)',
  //     'Interior & Trunk Vacuum',
  //     'Inside Wipedown'
  //   ]
  // },
  {
    name: 'Spect\'o',
    displayName: 'Platinum Package',
    price: 69,
    points: [
      'Detailed Exterior Hand Wash',
      'Tyre Shine & Rim Clean',
      'Windows Cleaned (Inside + Outside)',
      'Thorough Interior & Trunk Vacuum',
      'Inside Wipedown',
      'Bug & Tar Removal',
      'Complete Wax For Protect & Shine'
    ]
  },
];

class ChooseType extends Component {

  constructor(props) {
    super(props);

    this.selectWash = this.selectWash.bind(this);
  }

  selectWash(washType) {
    this.props.updateField('washType', washType.name.replace(/[^a-zA-Z]/g, ''));
    this.props.updateField('washTypeDisplay', washType.displayName);
    this.props.updateField('washPrice', washType.price + (this.props.details.carType === 'SUV' ? 10 : 0));
    this.props.next();
  }

  render() {
    const styles = {
      flexContainer: {
        display: 'flex',
        flexWrap: 'wrap'
      },
      cardContainer: {
        textAlign: 'center',
        justifyContent: 'center',
        width: '90%',
        margin: 5,
        minWidth: 200,
        flex: 1,
        position: 'relative',
        paddingBottom: 30,
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        paddingTop: 10,
        marginBottom: 20
      },
      card: {
        textAlign: 'center',
        justifyContent: 'center',
        display: 'flex',
        flex: 1
      },
      cardTitle: {
        marginBottom: 0,
        color: Theme.palette.primary1Color
      },
      center: {
        textAlign: 'center',
        justifyContent: 'center'
      },
      list: {
        textAlign: 'center'
      },
      li: {
        textAlign: 'left',
        lineHeight: '24px'
      },
      selectDiv: {
        height: '100%'
      },
      priceText: {
        fontWeight: 'bold',
        fontSize: '1.5em'
      },
      backButton: {
        width: 80,
        margin: 20
      }
    };

    return (
      <div style={styles.center}>
      {this.props.details.isSmallScreen && <h2 style={styles.title}>Choose Your Wash</h2>}
        <div style={styles.flexContainer}>
        {washTypes.map((washType, idx) => {
          const containerStyle = JSON.parse(JSON.stringify(styles.cardContainer));
          {/*if (washType.displayName !== 'Platinum Package') {
            Object.assign(containerStyle, { visibility: 'hidden' });
          }*/}
          return (
            <Card
              style={containerStyle}
              key={washType.name}
            >
              <h2 style={styles.cardTitle}>{washType.displayName}</h2>
              <CardText
                style={styles.card}
              >
                <ul style={styles.list}>
                {washType.points.map((point, idx) => {
                  return (
                    <li key={idx} style={styles.li}>{point}</li>
                  );
                })}
                </ul>
              </CardText>
              <div style={styles.priceText}>
                ${(washType.price + (this.props.details.carType === 'SUV' ? 10 : 0)).toFixed(2)}
              </div>
            </Card>
          );
        })}
        </div>
        <RaisedButton style={styles.backButton}
          label="Back" primary={true} onClick={this.props.back} />
        <RaisedButton
          label="Select"
          primary={true}
          onClick={() => this.selectWash(washTypes[0])}
        />
      </div>
    );
  }
}

export default ChooseType;



// WEBPACK FOOTER //
// ./src/components/ChooseType.js